// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detailItem .detailTitle[data-v-2734efb3]{background-color:#fff;width:100%;line-height:50px;border-bottom:1px solid #0755a2}.detailItem .detailTitle>h4[data-v-2734efb3]{margin-left:30px;letter-spacing:2px;font-weight:500;font-size:16px}.detailItem .detailContent[data-v-2734efb3]{background-color:#fff;width:98%;height:auto;margin:10px auto;border-radius:3px}", ""]);
// Exports
module.exports = exports;
